// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2utvb","notes":"Notes_notes__24T24","note":"Notes_note__10kBv","markdown":"Notes_markdown__3lRg7"};